import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import { connect } from 'react-redux';
import SubmitButton from 'form/SubmitButton';
import Tooltip from 'components/Tooltip';

@withRouter

@connect((state, props) => ({
  initialValues: props.site && props.site.attributes,
}))

@reduxForm({
  form: 'CustomDomain',
  onSubmit(values, dispatch, props) {
    const { site } = props;

    return dispatch(api.setCustomDomain(
      { id: site.id },
      {
        data: {
          type: 'site',
          attributes: {
            customDomain: values.customDomain,
          },
        },
      },
    ))
    .then(() => {
      props.history.push(`/site/${site.id}`);
      dispatch(notice('CustomDomain.success'));
    })
    .catch((response) => {
      dispatch(alert('CustomDomain.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class CustomDomain extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;
    return (
      <div>
        <div>
          <div>
            Configure your DNS records and add your domain below afterwards.
            {' '}
            <Tooltip label="Click for help">
              <a href="https://www.hardypress.com/guides/add-an-existing-domain-to-your-hardypress-website/" target="_blank" rel="noopener noreferrer">
                <i className="icon--question-circle" />
              </a>
            </Tooltip>
          </div>
          <div>
            <span>Point your CNAME to </span>
            <strong>cdn.hardypress.com</strong>
          </div>
        </div>
        <br />
        <Form error={error} onSubmit={handleSubmit}>
          <Field label="CustomDomain.customDomain" name="customDomain" placeholder="www.example.com">
            <input type="text" className="form__input--large" />
          </Field>
          <SubmitButton
            dirty={dirty}
            className="button button--primary button--expand button--huge"
            submitting={submitting}
            label="CustomDomain.submit"
          />
        </Form>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/CustomDomain.jsx